import mhsDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const mhsReducer = mhsDispatcher(initialState, {
  [mhsDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [mhsDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  })
});

export default mhsReducer;
